import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';

export interface FormActionsProps {
  /** Label for the submit button. */
  submitLabel: React.ReactNode;
  /** Whether the underlying mutation is pending. Disables submit and swaps label. */
  isSubmitting?: boolean;
  /** Force-disable submit (overrides isSubmitting label swap behavior). */
  submitDisabled?: boolean;
  /** Optional extra controls (cancel link, secondary actions). Rendered before submit. */
  children?: React.ReactNode;
  className?: string;
}

/**
 * Standard right-aligned form footer. Renders extra actions (`children`) and a
 * primary submit button with built-in loading state.
 */
export function FormActions({
  submitLabel,
  isSubmitting,
  submitDisabled,
  children,
  className,
}: FormActionsProps) {
  const { t } = useTranslation();
  return (
    <div className={['flex justify-end gap-2', className].filter(Boolean).join(' ')}>
      {children}
      <Button type="submit" disabled={submitDisabled || isSubmitting}>
        {isSubmitting ? t('common.loading') : submitLabel}
      </Button>
    </div>
  );
}
